<!--绘图参数部分-->
<template>
  <div>
    <!--    {{folder}}-->
    <!--    失败日志提醒-->
    <el-dialog
      :append-to-body="true"
      :title="drawErrTitle"
      :visible.sync="dialogVisible"
      width="30%">
      <div>
        <span>失败原因：{{ drawErrMess }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>
    <!--    绘制提醒-->
    <LoadingDialog v-if="drawingNotice" :showDialog="drawingNotice"
                   :dialogMessage="showAddLoadingMess"></LoadingDialog>
    <el-form :style="'margin-left: 5%;width:100%;'" v-if="isParamState" :disabled="!isReRunAnalyze"
             :title="isReRunAnalyze?'':'项目的版本已发生重大改变，无法在线绘图。请重跑该分析'">
      <!--      重跑分析-->
      <!--      <re-run-analyze v-if="showReRunAnalyzeDialog" :groupSample="reRunGroupSample" @submitData="reRunAnalyze" :analyze-id="analyzeId"></re-run-analyze>-->
      <!--参数-->
      <el-tabs type="card" v-model="activeName" :style="isReRunAnalyze?'':'opacity: 0.5;'">
        <el-tab-pane label="数据布局参数" name="shape">
          <el-form label-position="left">
            <div v-if="selectShape" style="width:90%">
              <div v-if="param.showEnv">
                <el-form-item label="是否显示环境因子：">
                  <el-select v-model="showEnvValue" class="select_inline">
                    <el-option label="yes" value="true">
                    </el-option>
                    <el-option label="no" value="false">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div v-if="param.directionOfBar">
                <el-form-item label="条形图方向：">
                  <el-select v-model="directionOfBarValue" class="select_inline">
                    <el-option label="水平" value="h">
                    </el-option>
                    <el-option label="垂直" value="v">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div v-if="param.layout">
                <el-form-item label="布局方式：">
                  <div class="shapeStyle">
                    <el-select v-model="layoutValue" class="select_inline">
                      <el-option label="向下" value="lower">
                      </el-option>
                      <el-option label="向上" value="upper">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.keystoneSpeciesTopNum">
                <el-form-item label="关键物种top数量：">
                  <div class="shapeStyle">
                    <el-select v-model="keystoneSpeciesTopNumValue" class="select_inline">
                      <el-option label="全部" :value="0">
                      </el-option>
                      <el-option label="10" :value="10">
                      </el-option>
                      <el-option label="20" :value="20">
                      </el-option>
                      <el-option label="30" :value="30">
                      </el-option>
                      <el-option label="50" :value="50">
                      </el-option>
                      <el-option label="100" :value="100">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.metabolinTopNum">
                <el-form-item label="代谢物top数量：">
                  <div class="shapeStyle">
                    <el-select v-model="metabolinTopNumValue" class="select_inline">
                      <el-option label="全部" :value="0">
                      </el-option>
                      <el-option label="10" :value="10">
                      </el-option>
                      <el-option label="20" :value="20">
                      </el-option>
                      <el-option label="30" :value="30">
                      </el-option>
                      <el-option label="50" :value="50">
                      </el-option>
                      <el-option label="100" :value="100">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.drawMethod" class="colorModel">
                <el-form-item label="绘制选项：">
                  <div class="shapeStyle">
                    <el-select v-model="drawMethodValue" class="select_inline">
                      <el-option label="仅绘制差异显著特征" value="diff">
                      </el-option>
                      <el-option label="绘制全部" value="all">
                      </el-option>
                      <el-option label="指定一个特征绘制(仅差异显著)" value="one">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <el-form-item label="格子上是否显示数字：" v-if="param.displayNumber" label-width="155px">
                <el-select v-model="displayNumberValue" class="select_inline">
                  <el-option label="yes" value="TRUE">
                  </el-option>
                  <el-option label="no" value="FALSE">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-if="param.showXYNames">
                <el-form-item label="是否显示X轴名字：">
                  <el-select v-model="showXNameValue" class="select_inline">
                    <el-option label="yes" value="TRUE">
                    </el-option>
                    <el-option label="no" value="FALSE">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否显示Y轴名字：">
                  <el-select v-model="showYNameValue" class="select_inline">
                    <el-option label="yes" value="TRUE">
                    </el-option>
                    <el-option label="no" value="FALSE">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <el-form-item label="是否显示列名：" v-if="param.showColNames">
                <el-select v-model="showColNamesValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否显示行名：" v-if="param.showRowNames">
                <el-select v-model="showRowNamesValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否行聚集：" v-if="param.clusterRows">
                <el-select v-model="clusterRowsValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否列聚集：" v-if="param.clusterCols">
                <el-select v-model="clusterColsValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否显示Y轴数字：" v-if="param.displayNumbers">
                <el-select v-model="displayNumbersValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label-width="180px" label="是否合并同分组的样本线：" v-if="param.isMerge">
                <el-select v-model="isMergeValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否显示节点标签：" v-if="param.showNodeLabel">
                <el-select v-model="showNodeLabelValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否展示标签：" v-if="param.displayLabel">
                <el-select v-model="displayLabelValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否展示样本名：" v-if="param.showText">
                <el-select v-model="showTextValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否展示圆：" v-if="param.displayCircle">
                <el-select v-model="displayCircleValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否绘制平均线：" v-if="param.drawMean">
                <el-select v-model="drawMeanValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否绘制中位线：" v-if="param.drawMedian">
                <el-select v-model="drawMedianValue" class="select_inline">
                  <el-option label="yes" value="true">
                  </el-option>
                  <el-option label="no" value="false">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="类名标签旋转角度：" v-if="param.classLabTrans" label-width="140px">
                <el-select v-model="classLabTransValue" class="select_inline">
                  <el-option label="0" value="0">
                  </el-option>
                  <el-option label="45" value="45">
                  </el-option>
                  <el-option label="90" value="90">
                  </el-option>
                  <el-option label="135" value="135">
                  </el-option>
                  <el-option label="270" value="270">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="X轴范围(min-max)：" v-if="param.xAxisLim">
                <div class="shapeStyle">
                  <div style="padding: 0px!important;">
                    <el-input v-model="xAxisLimMinValue" placeholder="填写数字" class="betweenInput"
                              name="xAxisLimMinValue"
                              v-validate="{number1:true }"
                              @blur="disappear('x')"></el-input>
                    <span class="errValMess">{{ errors.first("xAxisLimMinValue") }}</span>
                  </div>
                  <span class="lineBetween">--</span>
                  <div>
                    <el-input v-model="xAxisLimMaxValue" placeholder="填写数字" class="betweenInput"
                              name="xAxisLimMaxValue"
                              v-validate="{number1:true }"
                              @blur="compare('x')" @focus="disappear('x')"></el-input>
                    <span class="errValMess">{{ errors.first("xAxisLimMaxValue") }}</span>
                  </div>
                  <span v-if="xErrNumber" class="errMess">最大值必须大于最小值</span>
                  <!--                <span v-if="err.errXAxisLim=!checkMes(xAxisLimMinValue,'number')||!checkMes(xAxisLimMaxValue,'number')"-->
                  <!--                      class="errMess">{{ errMess }}</span>-->
                </div>
              </el-form-item>
              <el-form-item label="Y轴范围(min-max)：" v-if="param.yAxisLim">
                <div class="shapeStyle">
                  <div>
                    <el-input v-model="yAxisLimMinValue" placeholder="填写数字" class="betweenInput"
                              name="xAxisLimMaxValue"
                              v-validate="{number1:true }"
                              @blur="disappear('y')"></el-input>
                    <span class="errValMess">{{ errors.first("yAxisLimMinValue") }}</span>
                  </div>
                  <span class="lineBetween">--</span>
                  <div>
                    <el-input v-model="yAxisLimMaxValue" placeholder="填写数字" class="betweenInput"
                              name="yAxisLimMaxValue"
                              v-validate="{number1:true }"
                              @blur="compare('y')" @focus="disappear('y')"></el-input>
                    <span class="errValMess">{{ errors.first("yAxisLimMaxValue") }}</span>
                  </div>
                  <span v-if="yErrNumber" class="errMess">最大值必须大于最小值</span>
                </div>
              </el-form-item>
              <el-form-item label="Z轴范围(min-max)：" v-if="param.zAxisLim">
                <div class="shapeStyle">
                  <div>
                    <div>
                      <el-input v-model="zAxisLimMinValue" placeholder="填写数字" class="betweenInput"
                                name="zAxisLimMinValue"
                                v-validate="{number1:true }"
                                @blur="disappear('z')" @focus="disappear('z')"></el-input>
                      <span class="errValMess">{{ errors.first("zAxisLimMinValue") }}</span>
                    </div>
                  </div>
                  <span class="lineBetween">--</span>
                  <div>
                    <el-input v-model="zAxisLimMaxValue" placeholder="填写数字" class="betweenInput"
                              name="zAxisLimMaxValue"
                              v-validate="{number1:true }"
                              @blur="compare('z')" @focus="disappear('z')"></el-input>
                    <span class="errValMess">{{ errors.first("zAxisLimMaxValue") }}</span>
                  </div>
                  <span v-if="zErrNumber" class="errMess" style="color: #b05252">最大值必须大于最小值</span>
                </div>
              </el-form-item>
              <el-form-item label="原点坐标（X:Y）：" v-if="param.originPoint">
                <div class="shapeStyle">
                  <div>
                    <el-input v-model="originXPointValue" placeholder="填写数字" class="betweenInput"
                              name="originXPointValue"
                              v-validate="{number1:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("originXPointValue") }}</span>
                  </div>
                  <span class="lineBetween"> ：</span>
                  <div>
                    <el-input v-model="originYPointValue" placeholder="填写数字" class="betweenInput"
                              name="originYPointValue"
                              v-validate="{number1:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("originYPointValue") }}</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item v-if="param.labLevelStart||param.labLevelEnd">
                <!--              //todo-->
                <div class="shapeStyle">
                  <label class="wenHaoValue">绘制标签的分类学级别范围:
                    <el-tooltip
                      content="(初始-最终)该参数可以用来避免给没有有效信息的内部分类群添加标签。同时，可以去除大部分外部分类群，来避免标签太过密集或重叠。"
                      placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <div>
                    <el-input v-model="labLevelStartValue" placeholder="填写数字" class="betweenInput"
                              name="labLevelStartValue"
                              v-validate="{number:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("labLevelStartValue") }}</span>
                  </div>
                  <span class="lineBetween">--</span>
                  <div>
                    <el-input v-model="labLevelEndValue" placeholder="填写数字" class="betweenInput"
                              name="labLevelEndValue"
                              v-validate="{number:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("labLevelEndValue") }}</span>
                  </div>
                  <span v-if="err.errLabLevelStartEnd=checkRang(labLevelStartValue,labLevelEndValue)"
                        style="color: #b05252" class="errMess">最大值必须大于最小值</span>
                </div>
              </el-form-item>
              <el-form-item v-if="param.labAbbreLevelStart||param.labAbbreLevelEnd">
                <div class="shapeStyle">
                  <label class="wenHaoValue">标签缩写的分类学级别范围:
                    <el-tooltip content="设置分类学级别范围(初始-最终)，该参数用来构造分类群全名的缩写。" placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <div>
                    <el-input v-model="labAbbreLevelStartValue" placeholder="填写数字" class="betweenInput"
                              name="labAbbreLevelStartValue"
                              v-validate="{number:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("labAbbreLevelStartValue") }}</span>
                  </div>
                  <span class="lineBetween">--</span>
                  <div>
                    <el-input v-model="labAbbreLevelEndValue" placeholder="填写数字" class="betweenInput"
                              name="labAbbreLevelEndValue"
                              v-validate="{number:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("labAbbreLevelEndValue") }}</span>
                  </div>
                  <span v-if="err.labAbbreLevelStartEnd=checkRang(labAbbreLevelStartValue,labAbbreLevelEndValue)"
                        style="color: #b05252">最大值必须大于最小值</span>
                </div>
              </el-form-item>
              <el-form-item label="分类群节点大小范围：" v-if="param.nodeSizeMin||param.nodeSizeMax">
                <div class="shapeStyle">
                  <div>
                    <el-input v-model="nodeSizeMinValue" placeholder="填写数字" class="betweenInput"
                              name="nodeSizeMinValue"
                              v-validate="{number:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("nodeSizeMinValue") }}</span>
                  </div>
                  <span class="lineBetween">--</span>
                  <div>

                  </div>
                  <div>
                    <el-input v-model="nodeSizeMaxValue" placeholder="填写数字" class="betweenInput"
                              name="nodeSizeMaxValue"
                              v-validate="{number:true }"
                    ></el-input>
                    <span class="errValMess">{{ errors.first("nodeSizeMaxValue") }}</span>
                  </div>
                  <span v-if="err.labAbbreLevelStartEnd=checkRang(nodeSizeMinValue,nodeSizeMaxValue)"
                        style="color: #b05252" class="errMess">最大值必须大于最小值</span>
                </div>
              </el-form-item>
              <el-form-item v-if="param.yMin">
                <div class="shapeStyle">
                  <label class="wenHaoValue">y值最小值:
                    <el-tooltip content="设置-1表示自动计算y值最小值，该参数由0与90%的最小丰度值之间的最大值所得。"
                                placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <!--                //todo-->
                  <el-input v-model="yMinValue" name="yMinValue"
                            v-validate="{number1:true }"></el-input>
                  <span class="errMess" v-show="errors.has('yMinValue')">{{ errors.first("yMinValue") }}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="param.treeRoot">
                <div class="shapeStyle">
                  <label class="wenHaoValue">设置树的根节点:
                    <el-tooltip content="输入分类群的全名，分类群级别之间用“.”符号分隔。不填，默认根节点是最高级别分类群。"
                                placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <el-input v-model="treeRootValue"></el-input>
                </div>
              </el-form-item>
              <el-form-item v-if="param.yMax">
                <div class="shapeStyle">
                  <label class="wenHaoValue">y值最大值:
                    <el-tooltip
                      content="设置-1表示自动计算y值最大值，该参数将由最高丰度值和三倍的最高副类中位数之间的最小值所得。"
                      placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <el-input v-model="yMaxValue" name="yMaxValue"
                            v-validate="{number1:true }"></el-input>
                  <span class="errMess" v-show="errors.has('yMaxValue')">{{ errors.first("yMaxValue") }}</span>
                </div>
              </el-form-item>

              <el-form-item v-if="param.rightSpaceProp" label-position="top">
                <div class="shapeStyle">
                  <label class="wenHaoValue">右侧的水平空间比例：
                    <el-tooltip content="以防标签名太长而导致标签图例需要更多空间，可以通过这个参数扩大右边标签图例占比。"
                                placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <el-input v-model="rightSpacePropValue" name="rightSpacePropValue"
                            v-validate="{number:true }"></el-input>
                  <span class="errMess"
                        v-show="errors.has('rightSpacePropValue')">{{ errors.first("rightSpacePropValue") }}</span>
                </div>
              </el-form-item>
              <el-form-item label="图例列数：" v-if="param.legendncol">
                <div class="shapeStyle">
                  <el-input v-model="legendncolValue" name="legendncolValue"
                            v-validate="{int:true }"></el-input>
                  <span class="errMess" v-show="errors.has('legendncolValue')">{{
                      errors.first("legendncolValue")
                    }}</span>
                  <!--                <span v-if="err.errLegendncol=!checkMes(legendncolValue,'int')" class="errMess">{{ errMessInt }}</span>-->
                </div>
              </el-form-item>

              <el-form-item label="线到右边的距离：" v-if="param.rightSpaceNumber">
                <div class="shapeStyle">
                  <el-input v-model="rightSpaceNumberValue" name="rightSpaceNumberValue"
                            v-validate="{number:true }"></el-input>
                  <span class="errMess"
                        v-show="errors.has('rightSpaceNumberValue')">{{ errors.first("rightSpaceNumberValue") }}</span>
                </div>
              </el-form-item>

              <el-form-item label="图片宽度：" v-if="param.width">
                <div class="shapeStyle">
                  <el-input v-model="widthValue" placeholder="输入宽度" name="widthValue"
                            v-validate="{number:true }"></el-input>
                  <span class="errMess" v-show="errors.has('widthValue')">{{ errors.first("widthValue") }}</span>
                </div>
              </el-form-item>
              <el-form-item label="图片高度：" v-if="param.height">
                <div class="shapeStyle">
                  <el-input v-model="heightValue" placeholder="输入高度" name="heightValue"
                            v-validate="{number:true }"></el-input>
                  <span class="errMess" v-show="errors.has('heightValue')">{{ errors.first("heightValue") }}</span>
                </div>
              </el-form-item>
              <el-form-item v-if="param.lda">
                <div class="shapeStyle">
                  <label class="wenHaoValue">LDA值：
                    <el-tooltip content="根据LDA值筛选差异物种，默认值为2" placement="top">
                      <i class="el-icon-question elIconQuestion"></i>
                    </el-tooltip>
                  </label>
                  <el-input v-model="ldaValue" name="ldaValue"
                            v-validate="{number:true }"></el-input>
                  <span class="errMess" v-show="errors.has('ldaValue')">{{ errors.first("ldaValue") }}</span>
                </div>
              </el-form-item>
            </div>
          </el-form>

        </el-tab-pane>
        <el-tab-pane label="颜色参数" name="color" v-if="colorParam">
          <el-form style="width: 95%" label-position="left">
            <div class="colorModel">
              <div class="divBorder" :style="mapColors.length>8?'height:420px;overflow-y: auto':''"
                   v-if="param.mapColor">
                <p style="font-size: 13px;color: #aba8a8">
                  根据分组数量,颜色自动渐变分配。输入色值越多，色差越大，分组颜色区分度越大</p>
                <p style="font-size: 14px;margin-bottom: 20px"> 自定义颜色：</p>
                <el-form-item v-for="(color,index) in mapColors" style="vertical-align: center;">
                  <div style="display: flex;width: 100%;align-items: center;justify-content: space-between;"
                       :key="index">
                    <el-input v-model="color.value" style="min-width: 100px" :key="index+'elem.value'"
                              :name="`mapColor_${index}`"
                              v-validate="{color:true,required: true}"></el-input>
                    <el-color-picker v-model="color.value" class="colorPicker" :key="index+color.value"
                                     @change="handleColorChange(`mapColor_${index}`)"
                                     :predefine="predefineColors"></el-color-picker>
                    <span v-show="errors.has(`mapColor_${index}`)"
                          class="errMess">{{ errors.first(`mapColor_${index}`) }}</span>
                    <div style="display:flex;align-items: center;margin-left: 20px">
                      <div style="margin-right: 10px;display: flex;align-items: center">
                        <i class="el-icon-delete" style="font-size: 25px;color: #404040;cursor: pointer"
                           @click="deleteColor(index)" title="删除"></i>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-button type="success" @click="addColor">增加颜色</el-button>
              </div>
              <div v-if="param.color" style="width:100%;margin-bottom: 30px;">
                <div class="divBorder" :style="this.colorLab.length>8?'height:420px;overflow-y: auto;':''">
                  <div v-for="(color,index) in colorLab" style="align-items: center; width: 100%" :key="index">
                    <el-form-item :label="color.value+'：'" style="width: 100%;">
                      <div style="display: flex;align-items: center;justify-content: space-between; ">
                        <div style="display: flex;width: 100%;align-items: center;justify-content: space-between;"
                             :key="index">
                          <el-input v-model="colors[index].value" style="min-width:100px" :key="index"
                                    :name="`colors_${index}`"
                                    v-validate="{color:true,required: true}"></el-input>
                          <el-color-picker v-model="colors[index].value" class="colorPicker"
                                           @change="handleColorChange(`colors_${index}`)"
                                           :predefine="predefineColors"></el-color-picker>
                          <span v-show="errors.has(`colors_${index}`)" class="errMess">{{
                              errors.first(`colors_${index}`)
                            }}</span>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div v-if="param.groupColor" class="divBorder"
                   :style="this.groupColorLabel.length>8?'height:420px;overflow-y: auto':''">
                <p style="font-size: 15px">{{ nonGroup ? '颜色：' : '分组颜色：' }}</p>
                <div v-for="(color,index) in groupColorLabel" class="colorModel" :key="index">
                  <el-form-item :label="color.value+'：'" style="width: 100%;">
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                      <el-input v-model="groupColors[index].value" style="min-width:100px" :key="index"
                                :name="`groupColors_${index}`"
                                v-validate="{color:true,required: true}"></el-input>
                      <el-color-picker v-model="groupColors[index].value" class="colorPicker"
                                       :name="`groupColors_${index}`"
                                       v-validate="{color:true}" @change="handleColorChange(`groupColors_${index}`)"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess"
                            v-show="errors.has(`groupColors_${index}`)">{{
                          errors.first(`groupColors_${index}`)
                        }}</span>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div v-if="param.borderColor"
                   style="border: 1px solid #ced5d5;width: 100%;padding: 2% 5% 4% 5%;margin-bottom: 30px">
                <el-form-item label="边界颜色：">
                </el-form-item>
                <div v-for="(color,index) in borderColors"
                     style="vertical-align: center; display: flex;margin-left: 80px">
                  <el-input v-model="color.value" class="colorInput" :key="index" :name="`borderColor`"
                            v-validate="{color:true,required: true}"></el-input>
                  <div class="colorPickerFont">
                    <el-color-picker v-model="color.value" class="colorPicker"
                                     @change="handleColorChange('borderColor')"
                                     :predefine="predefineColors"></el-color-picker>
                    <span class="errMess" v-show="errors.has('borderColor')">{{ errors.first(`borderColor`) }}</span>
                  </div>
                </div>
              </div>


              <div v-if="param.circleColor" class="colorModel">
                <el-form-item label="中心圆颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="circleColorValue" class="colorInput" :name="`circleColor`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="circleColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('circleColor')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('circleColor')">{{ errors.first(`circleColor`) }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.axisColor" class="colorModel">
                <el-form-item label="坐标轴颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="axisColorValue" class="colorInput" :name="`axisColor`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="axisColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('axisColor')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('axisColor')">{{ errors.first(`axisColor`) }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.gridColor" class="colorModel">
                <el-form-item label="格子颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="gridColorValue" class="colorInput" :name="`gridColor`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="gridColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('gridColor')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('gridColor')">{{ errors.first(`gridColor`) }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.borderNumberCol" style="width:100%">
                <el-form-item label="格子边框颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="borderColorValue" class="colorInput" :name="`borderNumberCol`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="borderColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('borderNumberCol')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('borderNumberCol')">{{
                          errors.first(`borderNumberCol`)
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="字符颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="numberColorValue" class="colorInput" :name="`numberColorValue`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="numberColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('numberColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('numberColorValue')">{{
                          errors.first(`numberColorValue`)
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.sampleNameColor" class="colorModel">
                <el-form-item label="样本名颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="sampleNameColorValue" class="colorInput" name="sampleNameColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="sampleNameColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('sampleNameColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess"
                            v-show="errors.has('sampleNameColorValue')">{{
                          errors.first('sampleNameColorValue')
                        }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.enviLineColor" style="width:100%">
                <el-form-item label="环境因子坐标线颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="enviLineColorValue" class="colorInput" name="enviLineColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="enviLineColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('enviLineColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess"
                            v-show="errors.has('enviLineColorValue')">{{ errors.first('enviLineColorValue') }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.envText||param.envTextColor" class="colorModel">
                <el-form-item label="环境因子字体颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="envTextColorValue" class="colorInput" name="envTextColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="envTextColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('envTextColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('envTextColorValue')">{{
                          errors.first('envTextColorValue')
                        }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.envTextBGColor" style="width:100%">
                <el-form-item label="环境因子字体背景颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="envTextBGColorValue" class="colorInput" name="envTextBGColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="envTextBGColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('envTextBGColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess"
                            v-show="errors.has('envTextBGColorValue')">{{ errors.first('envTextBGColorValue') }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.lineColor" style="width:100%">
                <el-form-item label="线的颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="lineColorValue" class="colorInput" name="lineColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="lineColorValue" class="colorPicker"
                                       @change="handleColorChange('lineColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('lineColorValue')">{{
                          errors.first('lineColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.numberColor" style="width:100%">
                <el-form-item label="字体颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="numberColorValue" class="colorInput" :name="`numberColorValue`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="numberColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('numberColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('numberColorValue')">{{
                          errors.first(`numberColorValue`)
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.bgc" style="width:100%">
                <el-form-item label="背景色：">
                  <div class="input_pick_msg">
                    <el-input v-model="bgcValue" class="colorInput" :name="`bgcValue`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="bgcValue"
                                       class="colorPicker"
                                       @change="handleColorChange('bgcValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('bgcValue')">{{
                          errors.first(`bgcValue`)
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.pointColor" style="width:100%">
                <el-form-item label="散点颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="pointColorValue" class="colorInput" :name="`pointColorValue`"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="pointColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('pointColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('pointColorValue')">{{
                          errors.first(`pointColorValue`)
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>

              <div v-if="param.abundanceColor" class="colorModel">
                <el-form-item label="元素丰富度颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="abundanceColorValue" class="colorInput" name="abundanceColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="abundanceColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('abundanceColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess"
                            v-show="errors.has('abundanceColorValue')">{{ errors.first('abundanceColorValue') }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.histColor" class="colorModel">
                <el-form-item label="柱状图颜色：" label-width="120px">
                  <div class="input_pick_msg">
                    <el-input v-model="histColorValue" class="colorInput" name="histColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="histColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('histColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('histColorValue')">{{
                          errors.first('histColorValue')
                        }}</span>
                    </div>

                  </div>
                </el-form-item>
              </div>
              <div v-if="param.dotMatrixColor" class="colorModel">
                <el-form-item label="点阵图颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="dotMatrixColorValue" class="colorInput" name="dotMatrixColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="dotMatrixColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('dotMatrixColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('dotMatrixColorValue')">{{
                          errors.first('dotMatrixColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.heapmapMaxColor" class="colorModel">
                <el-form-item label="热图最大值对应颜色：" label-width="155px">
                  <div class="input_pick_msg">
                    <el-input v-model="heapmapMaxColorValue" class="colorInput" name="heapmapMaxColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="heapmapMaxColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('heapmapMaxColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('heapmapMaxColorValue')">{{
                          errors.first('heapmapMaxColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.naColor" class="colorModel">
                <el-form-item label="热图值NA填充色：">
                  <div class="input_pick_msg">
                    <el-input v-model="naColorValue" class="colorInput" name="naColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="naColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('naColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('naColorValue')">{{
                          errors.first('naColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.communityColor" class="colorModel">
                <el-form-item label="微生物群落数据颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="communityColorValue" class="colorInput" name="communityColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="communityColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('communityColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('communityColorValue')">{{
                          errors.first('communityColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.metabolomeColor" class="colorModel">
                <el-form-item label="代谢组数据颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="metabolomeColorValue" class="colorInput" name="metabolomeColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="metabolomeColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('metabolomeColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('metabolomeColorValue')">{{
                          errors.first('metabolomeColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.negativeColor" class="colorModel">
                <el-form-item label="负相关颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="negativeColorValue" class="colorInput" name="negativeColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="negativeColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('negativeColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('negativeColorValue')">{{
                          errors.first('negativeColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.justColor" class="colorModel">
                <el-form-item label="正相关颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="justColorValue" class="colorInput" name="justColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="justColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('justColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('justColorValue')">{{
                          errors.first('justColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.metaboliteColor" class="colorModel">
                <el-form-item label="关键代谢物颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="metaboliteColorValue" class="colorInput" name="metaboliteColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="metaboliteColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('metaboliteColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('metaboliteColorValue')">{{
                          errors.first('metaboliteColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.speciesColor" class="colorModel">
                <el-form-item label="关键物种颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="speciesColorValue" class="colorInput" name="speciesColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="speciesColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('speciesColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('speciesColorValue')">{{
                          errors.first('speciesColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div v-if="param.lowToHighColor" class="colorModel">
                <el-form-item label="上部分颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="highColorValue" class="colorInput" name="highColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="highColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('highColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('highColorValue')">{{
                          errors.first('highColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="下部分颜色：">
                  <div class="input_pick_msg">
                    <el-input v-model="lowColorValue" class="colorInput" name="lowColorValue"
                              v-validate="{color:true,required: true}"></el-input>
                    <div class="colorPickerFont">
                      <el-color-picker v-model="lowColorValue"
                                       class="colorPicker"
                                       @change="handleColorChange('lowColorValue')"
                                       :predefine="predefineColors"></el-color-picker>
                      <span class="errMess" v-show="errors.has('lowColorValue')">{{
                          errors.first('lowColorValue')
                        }}</span>
                    </div>
                  </div>
                </el-form-item>

              </div>
              <div sclass="colorModel" v-if="param.diaphaneity">
                <el-form-item label="自定义椭圆透明度：" label-width="140px">
                  <el-slider
                    v-model="diaphaneityValue"
                    show-input
                    :max="1"
                    :min="0"
                    :step="0.1"
                  ></el-slider>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="字体参数" name="font" v-if="fontParam">
          <template>
            <el-form label-position="left" style="width: 90%">
              <div style="width: 100%;" class="fontTemplate">

                <el-form-item label="X轴标题大小：" v-if="param.xTitleSize" label-width="120px">
                  <el-slider
                    v-model="xTitleSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="Y轴标题大小：" v-if="param.yTitleSize" label-width="120px">
                  <el-slider
                    v-model="yTitleSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="坐标轴标题大小：" v-if="param.ls" label-width="135px">
                  <el-slider
                    v-model="lsValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="坐标轴字体大小：" v-if="param.ts" label-width="135px">
                  <el-slider
                    v-model="tsValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="X轴字体大小：" v-if="param.xSize" label-width="120px">
                  <el-slider
                    v-model="xSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="Y轴字体大小：" v-if="param.ySize" label-width="120px">
                  <el-slider
                    v-model="ySizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="标签字体大小：" v-if="param.labelFontSize" label-width="120px">
                  <el-slider
                    v-model="labelFontSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="主标题字体大小：" v-if="param.titleFontSize" label-width="130px">
                  <el-slider
                    v-model="titleFontSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="副题字体大小：" v-if="param.subTitleSize" label-width="120px">
                  <el-slider
                    v-model="subTitleSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="字体大小：" v-if="param.fontSize" label-width="100px">
                  <el-slider
                    v-model="fontSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="坐标轴字体大小：" v-if="param.axisFontSize3D" label-width="130px">
                  <el-slider
                    class="slideStyle"
                    v-model="axisFontSize3DValue"
                    show-input
                  ></el-slider>
                </el-form-item>
                <el-form-item label="坐标轴标题字体大小：" v-if="param.labSize" label-width="155px">
                  <el-slider
                    v-model="labSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="环境因子字体大小：" v-if="param.envText||param.envTextColor" label-width="140px">
                  <el-slider
                    v-model="envTextSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="类名字体大小：" v-if="param.classFontSize" label-width="130px">
                  <el-slider
                    v-model="classFontSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>

                <el-form-item label="图例大小：" v-if="param.legendSize">
                  <div class="shapeStyle">
                    <el-input v-model="legendSizeValue" name="legendSizeValue"
                              v-validate="{number:true }"></el-input>
                    <span class="errMess" v-show="errors.has('legendSizeValue')">{{
                        errors.first("legendSizeValue")
                      }}</span>
                  </div>
                </el-form-item>

                <el-form-item label="图例标题大小：" v-if="param.legendTitleSize">
                  <div class="shapeStyle">
                    <el-input v-model="legendTitleSizeValue" name="legendTitleSizeValue"
                              v-validate="{number:true }"></el-input>
                    <span class="errMess"
                          v-show="errors.has('legendTitleSizeValue')">{{ errors.first("legendTitleSizeValue") }}</span>
                  </div>
                </el-form-item>
                <el-form-item label="图例文字大小：" v-if="param.legendTextSize">
                  <div class="shapeStyle">
                    <el-input style="" v-model="legendTextSizeValue" name="legendTextSizeValue"
                              v-validate="{number:true }"></el-input>
                    <span class="errMess" v-show="errors.has('legendTextSizeValue')">{{
                        errors.first("legendTextSizeValue")
                      }}</span>
                  </div>
                </el-form-item>
                <el-form-item label="特征名最大长度：" v-if="param.featureNameMaxLen" label-width="130px">
                  <el-slider
                    v-model="featureNameMaxLenValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="副类名和Y轴字体大小：" v-if="param.subClassFontSize" label-width="165px">
                  <el-slider
                    v-model="subClassFontSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <div v-if="param.rowColumnInnerOfFont">
                  <el-form-item label="行名字体大小：" label-width="130px">
                    <el-slider
                      v-model="rowFontSizeValue"
                      show-input
                      class="slideStyle"
                    ></el-slider>
                  </el-form-item>
                  <el-form-item label="列名字体大小：" label-width="130px">
                    <el-slider
                      v-model="colFontSizeValue"
                      show-input
                      class="slideStyle"
                    ></el-slider>
                  </el-form-item>
                  <el-form-item label="格子内字体大小：" label-width="130px">
                    <el-slider
                      v-model="innerFontSizeValue"
                      show-input
                      class="slideStyle"
                    ></el-slider>
                  </el-form-item>
                </div>
                <el-form-item v-if="param.fsNumber" label="格子内字体大小：" label-width="130px">
                  <el-slider
                    v-model="innerFontSizeValue"
                    show-input
                    class="slideStyle"
                  ></el-slider>
                </el-form-item>
                <el-form-item v-if="param.labLevelNum">
                  <div style="display: flex">
                    <label class="wenHaoValue">要绘制的标签级别数:
                      <el-tooltip content="要绘制的标签级别数, -1 表示绘制所有, 1 为默认值。" placement="top">
                        <i class="el-icon-question elIconQuestion"></i>
                      </el-tooltip>
                    </label>
                    <el-input v-model="labLevelNumValue" name="labLevelNumValue"
                              v-validate="{int:true}"></el-input>
                    <span class="errMess" v-show="errors.has('labLevelNumValue')">{{
                        errors.first('labLevelNumValue')
                      }}</span>
                  </div>

                  <!--                <span v-if="err.errLabLevelNum=!checkMes(labLevelNumValue,'int')" class="errMess">{{-->
                  <!--                    errMessInt-->
                  <!--                  }}</span>-->
                </el-form-item>
                <el-form-item v-if="param.lowLevelGroupInterval">
                  <div class="shapeStyle">
                    <label class="wenHaoValue">较低级别分类群之间的间隔:
                      <el-tooltip
                        content="设置属于不同父分类群的较低级别分类群之间的间隔。根据该级别叶子节点密度，该参数会自动调节。"
                        placement="top">
                        <i class="el-icon-question elIconQuestion"></i>
                      </el-tooltip>
                    </label>
                    <el-input v-model="lowLevelGroupIntervalValue" name="lowLevelGroupIntervalValue"
                              v-validate="{number:true}"></el-input>
                    <span v-show="errors.has('lowLevelGroupIntervalValue')"
                          class="errMess">{{ errors.first('lowLevelGroupIntervalValue') }}</span>
                    <!--                  <span v-if="err.errLowLevelGroupInterval=!checkMes(lowLevelGroupIntervalValue,'number')"-->
                    <!--                        class="errMess">{{ errMess }}</span>-->
                  </div>
                </el-form-item>
                <el-form-item v-if="param.maxClassifyLevelNum">
                  <div class="shapeStyle">
                    <label class="wenHaoValue">最大分类学级别数:
                      <el-tooltip content="可以将分枝进化图的分类学级别限制在你期望的级别内。" placement="top">
                        <i class="el-icon-question elIconQuestion"></i>
                      </el-tooltip>
                    </label>
                    <el-input v-model="maxClassifyLevelNumValue" name="maxClassifyLevelNumValue"
                              v-validate="{int:true}"></el-input>
                    <span class="errMess" v-show="errors.has('maxClassifyLevelNumValue')">{{
                        errors.first('maxClassifyLevelNumValue')
                      }}</span>
                    <!--                  <span v-if="err.errMaxClassifyLevelNum=!checkMes(maxClassifyLevelNumValue,'int')"-->
                    <!--                        class="errMess">{{ errMessInt }}</span>-->
                  </div>
                </el-form-item>
                <el-form-item label="径向上外部级别的数量：" v-if="param.radialTopLevelNum">
                  <div class="shapeStyle">
                    <el-input v-model="radialTopLevelNumValue" name="radialTopLevelNumValue"
                              v-validate="{int:true}"></el-input>
                    <span class="errMess" v-show="errors.has('radialTopLevelNumValue')">{{
                        errors.first('radialTopLevelNumValue')
                      }}</span>
                    <!--                  <span v-if="err.errRadialTopLevelNum=!checkMes(radialTopLevelNumValue,'int')"-->
                    <!--                        class="errMess">{{ errMessInt }}</span>-->
                  </div>
                </el-form-item>
                <el-form-item label="进化枝标签透明度：" v-if="param.evolutionBranchLabDia">
                  <div class="shapeStyle">
                    <el-input v-model="evolutionBranchLabDiaValue" name="evolutionBranchLabDiaValue"
                              v-validate="{number:true}"></el-input>
                    <span class="errMess" v-show="errors.has('evolutionBranchLabDiaValue')">{{
                        errors.first('evolutionBranchLabDiaValue')
                      }}</span>
                    <!--                  <span v-if="err.errEvolutionBranchLabDia=!checkMes(evolutionBranchLabDiaValue,'number')"-->
                    <!--                        class="errMess">{{-->
                    <!--                      errMess-->
                    <!--                    }}</span>-->
                  </div>
                </el-form-item>
                <el-form-item label="分类群节点边缘线宽度：" v-if="param.nodeMarginLineWidth">
                  <div class="shapeStyle">
                    <el-input v-model="nodeMarginLineWidthValue" name="nodeMarginLineWidthValue"
                              v-validate="{number:true}"></el-input>
                    <span class="errMess" v-show="errors.has('nodeMarginLineWidthValue')">{{
                        errors.first('nodeMarginLineWidthValue')
                      }}</span>
                    <!--                  <span v-if="err.errNodeMarginLineWidth=!checkMes(nodeMarginLineWidthValue,'number')"-->
                    <!--                        class="errMess">{{ errMess }}</span>-->
                  </div>
                </el-form-item>
                <el-form-item label="兄弟节点连接线宽度：" v-if="param.sblingNodeConnLineWidth">
                  <div class="shapeStyle">
                    <el-input v-model="sblingNodeConnLineWidthValue" name="sblingNodeConnLineWidthValue"
                              v-validate="{number:true}"></el-input>
                    <span class="errMess" v-show="errors.has('sblingNodeConnLineWidthValue')">{{
                        errors.first('sblingNodeConnLineWidthValue')
                      }}</span>
                    <!--                  <span v-if="err.errSblingNodeConnLineWidth=!checkMes(sblingNodeConnLineWidthValue,'number')"-->
                    <!--                        class="errMess">{{ errMess }}</span>-->
                  </div>
                </el-form-item>
                <el-form-item label="父节点连接线宽度：" v-if="param.parentNodeConnLineWidth">
                  <div class="shapeStyle">
                    <el-input v-model="parentNodeConnLineWidthValue" name="parentNodeConnLineWidthValue"
                              v-validate="{number:true}"></el-input>
                    <span class="errMess" v-show="errors.has('parentNodeConnLineWidthValue')">{{
                        errors.first('parentNodeConnLineWidthValue')
                      }}</span>
                    <!--                  <span v-if="err.errParentNodeConnLineWidth=!checkMes(parentNodeConnLineWidthValue,'number')"-->
                    <!--                        class="errMess">{{ errMess }}</span>-->
                  </div>
                </el-form-item>


                <el-form-item label="主标题名字：" v-if="param.mainTitle">
                  <div class="shapeStyle">
                    <el-input v-model="mainTitleValue" placeholder="不能输入中文字体"
                              prop="mainTitleRule" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')"></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="标题名字1：" v-if="param.mainTitle2">
                  <div class="shapeStyle">
                    <el-input v-model="mainTitle2Value" placeholder="不能输入中文字体"
                              prop="mainTitleRule" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')"></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="字体样式：" v-if="param.family">
                  <el-select v-model="familyValue" placeholder="请选择字体样式" class="select_inline">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>

                </el-form-item>
                <template>
                </template>
              </div>
            </el-form>
          </template>

        </el-tab-pane>
        <el-tab-pane label="图表工具" v-if="pictureTool">
          <el-form-item v-if="param.groupOrder">
            <div style="display: flex">
              <label class="wenHaoValue">组排序
                <el-tooltip content="拖动右侧组名，调整组名在图中的排列顺序。排序大小为从左到右。" placement="top">
                  <i class="el-icon-question elIconQuestion"></i>
                </el-tooltip>
              </label>
              <draggable v-model="groupOrderValue">
                <el-tag style="margin-left: 10px;cursor: pointer"
                        v-for="(item,index) in groupOrderValue"
                        :key="item.value">{{ item.value }}
                </el-tag>
              </draggable>
            </div>
          </el-form-item>
          <el-form-item v-if="param.sampleOrder">
            <div style="display: flex">
              <label class="wenHaoValue">样本排序
                <el-tooltip content="拖动右侧样本名，调整样本名在图中的排列顺序。排序大小为从左到右" placement="top">
                  <i class="el-icon-question elIconQuestion"></i>
                </el-tooltip>
              </label>
              <draggable v-model="sampleOrderValue">
                <el-tag style="margin-left: 10px;cursor: pointer"
                        v-for="(item,index) in sampleOrderValue"
                        :key="item.value">{{ item.value }}
                </el-tag>
              </draggable>
            </div>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
      <el-button type="primary" style="width: 20%;margin-top: 30px;margin-left: 10%" @click="draw">
        绘制
      </el-button>
      <el-button type="primary" style="width: 22%;margin-top: 30px;margin-left: 5%;" @click="resetParam">
        重置参数
      </el-button>
    </el-form>
  </div>
</template>

<script>
import {checkIsColor, checkIsIntNumber, checkIsNumber, checkIsNumber1} from "@/utils/utils";
import $ from "jquery";
import {defaultColor} from '@/utils/PublicConstant'
import LoadingDialog from "@/components/LoadingDialog";
import {getAnalyzeGroupSampleNames, reRunAnalyze} from "@/api/analyze/analyze";
import draggable from 'vuedraggable'
import { getDataInSessionStorage } from '@/utils/sessionStorage'

export default {
  name: "ModifyParam",
  props: {
    analyzeId: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    },
    folder: {
      type: String,
      default: ""
    },
    countType: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
  },
  computed: {
    isParamState() {
      return this.$store.state.rightMenu.isParamState
    },
  },
  components: {
    LoadingDialog,
    draggable,
  },
  data() {
    return {
      showReRunAnalyzeDialog: false,
      reRunGroupSample: [],
      showAddLoadingMess: '绘制中,请耐心等待......',
      err: {
        errWidth: '',
        errHeight: '',
        errBordColor: '',
        errColor: [],
        errHighColor: '',
        errLowColor: '',
        errHistColor: '',
        errAbundanceColor: '',
        errLineColor: '',
        errEnvTextBGColor: '',
        errEnvTextColor: '',
        errEnviLineColor: '',
        errSampleNameColor: '',
        errNumberColor: '',
        errBorderColor: [],
        errGridColor: '',
        errAxisColor: '',
        errCircleColor: '',
        errMapColor: [],
        errGroupColor: [],
        errRightSpaceNumber: '',
        errLabLevelStartEnd: '',
        errEvolutionBranchLabDia: '',
        errNodeMarginLineWidth: '',
        errSblingNodeConnLineWidth: '',
        errParentNodeConnLineWidth: '',
        errRightSpaceProp: '',
        errLegendncol: '',
        errXAxisLim: '',
        errYAxisLim: '',
        errZAxisLim: '',
        errLegendSize: '',
        errLegendTextSize: '',
        errLegendTitleSize: '',
        errOriginPoint: '',
        errLabLevelStartEndInt: '',
        errLabAbbreLevelStartEndInt: '',
        errNodeSizeMinInt: '',
        errYMax: '',
        errYMin: '',
        errDrawMean: '',
        errDrawMedian: '',
        errSubClassFontSize: '',
        errClassLabTrans: '',
        lda: '',
      },
      drawingNotice: false,
      drawNotice: false,
      drawErrTitle: '',
      drawErrMess: '',
      dialogVisible: false,
      errMess: '',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577',
        '#d87c7c',
        '#919e8b',
        '#d7ab82',
        '#6e7074',
        '#111111',
        '#ffffff',
      ],
      activeName: 'shape',
      value: '',
      resultName: '',
      resultLength: '',
      menuState: true,
      selectFont: false,
      selectShape: true,
      selectColor: false,
      paramEmpty: false,
      colorParam: false,
      fontParam: false,
      pictureTool: false,
      xErrNumber: false,
      yErrNumber: false,
      zErrNumber: false,
      errColorForm: false,
      lastParam: [],
      defaultParam: [],
      param: {
        titleFontSize: false,//标题字体大小
        xTitleSize: false,//x轴标题字体大小
        yTitleSize: false,
        xSize: false,//x轴字体大小
        ySize: false,
        family: false,//字体样式
        xFamily: false,//x轴字体样式
        yFamily: false,
        mainTitle: false,//主标题内容
        labelFontSize: false,//标签字体大小
        color: false,
        borderColor: false,
        heightDefault: false,
        widthDefault: false,
        displayNumber: false,//是否显示格子里的数字
        showXYNames: false,//是否显示坐标轴的名字
        groupColor: false,

        circleColor: false,//中心圆颜色
        fontSize: false,//字体大小
        axisFontSize3D: false,//三维坐标轴字体大小
        legendSize: false,//图例大小
        xAxisLim: false,
        yAxisLim: false,
        zAxisLim: false,
        directionOfBar: false,
        // xErrNumber: false,
        // yErrNumber: false,
        // zErrNumber: false,
        labSize: false,
        axisColor: false,
        gridColor: false,
        sampleNameColor: false,
        enviLineColor: false,
        mainTitle2: false,
        legendTitleSize: false,//图例标题大小
        legendTextSize: false,//图例文字大小
        showEnv: false,
        originPoint: false,
        envText: false,
        envTextColor: false,
        envTextSize: false,
        envTextBGColor: false,
        borderNumberCol: false,
        lineColor: false,
        subTitleSize: false,
        abundanceColor: false,
        histColor: false,
        lowToHighColor: false,
        showColNames: false,
        showRowNames: false,
        clusterRows: false,
        clusterCols: false,
        displayNumbers: false,
        mapColor: false,
        rowColumnInnerOfFont: false,
        diaphaneity: false,
        flagColor: false,
        flagNumber: false,
        displayLabel: false,
        displayCircle: false,
        showText: false,
        isMerge: false,
        rightSpaceNumber: false,
        featureNameMaxLen: false,
        classFontSize: false,
        labLevelNum: false,
        labLevelStart: false,
        labLevelEnd: false,
        lowLevelGroupInterval: false,
        labAbbreLevelEnd: false,
        labAbbreLevelStart: false,
        maxClassifyLevelNum: false,
        evolutionBranchLabDia: false,
        nodeMarginLineWidth: false,
        sblingNodeConnLineWidth: false,
        parentNodeConnLineWidth: false,
        rightSpaceProp: false,
        radialTopLevelNum: false,
        legendncol: false,
        drawMethod: false,
        nodeSizeMin: false,
        nodeSizeMax: false,
        yMax: false,
        yMin: false,
        drawMean: false,
        drawMedian: false,
        subClassFontSize: false,
        classLabTrans: false,
        layout: false,
        keystoneSpeciesTopNum: false,
        metabolinTopNum: false,
        treeRoot: false,
        width: false,
        height: false,
        lda: false,
        groupOrder: false,
        sampleOrder: false,
        dotMatrixColor: false,   // 点阵图颜色
        heapmapMaxColor: false,   // 热图最大值对应颜色
        naColor: false,   // 热图值NA填充色
        communityColor: false,   // 微生物群落数据颜色
        metabolomeColor: false,   // 代谢组数据颜色
        ts: false,   //	坐标轴字体大小
        ls: false,   //	坐标轴标题大小
        showNodeLabel: false,   // 是否显示节点标签
        negativeColor: false,   // 负相关
        justColor: false,   //  正相关
        metaboliteColor: false,   // 关键代谢物
        speciesColor: false,   // 关键物种
        fs: false,   //  字体大小
        numberColor: false,   //  字体颜色
        bgc: false,   //  背景色
        alpha: false,   //  透明度
        pointColor: false,   //  散点颜色
        fsNumber: false,
      },
      titleFontSizeValue: '',//主标题字体大小
      xTitleSizeValue: '',//X轴标题大小
      yTitleSizeValue: '',
      xSizeValue: '',//X轴字体大小
      ySizeValue: '',
      familyValue: '',//字体样式
      xFamilyValue: '',
      yFamilyValue: '',
      mainTitleValue: '',//主标题名字
      heightValue: '',//图片高度
      widthValue: '',//图片宽度
      labelFontSizeValue: '',//标签字体大小
      displayNumberValue: '',//格子上是否显示数字
      showXNameValue: '',//是否显示X轴名字
      showYNameValue: '',//是否显示Y轴名字
      addClickNum: 0,
      groupColors: [],
      groupColorLabel: [],
      circleColorValue: '',//中心圆颜色
      diaphaneityValue: '',//自定义椭圆透明度
      fontSizeValue: '',//字体大小
      axisFontSize3DValue: '',//坐标轴字体大小
      legendSizeValue: '',//图例大小
      function: '',//方法
      xAxisLimMinValue: '',//X轴范围(min-max)
      xAxisLimMaxValue: '',
      yAxisLimMinValue: '',//Y轴范围(min-max)
      yAxisLimMaxValue: '',
      zAxisLimMinValue: '',//Z轴范围(min-max)
      zAxisLimMaxValue: '',
      labSizeValue: '',//坐标轴标题字体大小
      axisColorValue: '',//坐标轴颜色
      gridColorValue: '',//格子颜色
      sampleNameColorValue: '',//样本名颜色
      enviLineColorValue: '',//环境因子坐标线颜色
      mainTitle2Value: '',//标题名字1
      legendTitleSizeValue: '',//图例标题大小
      legendTextSizeValue: '',//图例文字大小
      showEnvValue: '',//是否显示环境因子
      originXPointValue: '',//原点坐标（X:Y）
      originYPointValue: '',
      envTextColorValue: '',//环境因子字体颜色
      envTextSizeValue: '',//环境因子字体大小
      envTextBGColorValue: '',//环境因子字体背景颜色
      borderColorValue: '',//格子边框颜色
      numberColorValue: '',//字符颜色
      lineColorValue: '',//线的颜色
      subTitleSizeValue: '',//副题字体大小
      abundanceColorValue: '',//元素丰富度颜色
      histColorValue: '',//柱状图颜色
      lowColorValue: '',//下部分颜色
      highColorValue: '',//上部分颜色
      showColNamesValue: '',//是否显示列名
      showRowNamesValue: '',//是否显示行名
      clusterRowsValue: '',//是否行聚集
      clusterColsValue: '',//是否列聚集
      displayNumbersValue: '',//是否显示Y轴数字
      mapColors: [],
      colors: [],
      colorLab: [],
      borderColors: [],//边界颜色
      returnParam: {},
      rowFontSizeValue: '',//行名字体大小
      colFontSizeValue: '',//列名字体大小
      innerFontSizeValue: '',//格子内字体大小
      displayLabelValue: '',//是否展示标签
      displayCircleValue: '',//是否展示圆
      showTextValue: '',//是否展示样本名
      isMergeValue: '',//是否合并同分组的样本线
      rightSpaceNumberValue: '',//线到右边的距离
      featureNameMaxLenValue: '',//特征名最大长度
      classFontSizeValue: '',//类名字体大小
      labLevelNumValue: '',
      directionOfBarValue: '',//条形图方向
      labLevelStartValue: '',//绘制标签的分类学级别范围
      labLevelEndValue: '',
      lowLevelGroupIntervalValue: '',//较低级别分类群之间的间隔
      maxClassifyLevelNumValue: '',//最大分类学级别数
      radialTopLevelNumValue: '',//径向上外部级别的数量
      labAbbreLevelStartValue: '',//标签缩写的分类学级别范围
      labAbbreLevelEndValue: '',
      evolutionBranchLabDiaValue: '',//进化枝标签透明度
      nodeMarginLineWidthValue: '',//分类群节点边缘线宽度
      sblingNodeConnLineWidthValue: '',//兄弟节点连接线宽度
      parentNodeConnLineWidthValue: '',//父节点连接线宽度
      rightSpacePropValue: '',//右侧的水平空间比例
      legendncolValue: '',//图例列数
      drawMethodValue: '',//绘制选项
      nodeSizeMinValue: '',//分类群节点大小范围
      nodeSizeMaxValue: '',
      yMaxValue: '',//y值最大值
      yMinValue: '',
      drawMeanValue: '',//是否绘制平均线
      drawMedianValue: '',//是否绘制中位线
      subClassFontSizeValue: '',//副类名和Y轴字体大小
      classLabTransValue: '',//类名标签旋转角度
      layoutValue: '',//布局方式
      keystoneSpeciesTopNumValue: '',//关键物种top数量
      metabolinTopNumValue: '',//代谢物top数量
      treeRootValue: '',
      ldaValue: '',//LDA值
      groupOrderValue: '',//组排序
      sampleOrderValue: '',//样本排序
      dotMatrixColorValue: '',// 点阵图颜色
      heapmapMaxColorValue: '',// 热图最大值对应颜色
      naColorValue: '',// 热图值NA填充色
      communityColorValue: '',// 微生物群落数据颜色
      metabolomeColorValue: '',// 代谢组数据颜色
      tsValue: '',//	坐标轴字体大小
      lsValue: '',//	坐标轴标题大小
      showNodeLabelValue: '',// 是否显示节点标签
      negativeColorValue: '',// 负相关
      justColorValue: '',//  正相关
      metaboliteColorValue: '',// 关键代谢物
      speciesColorValue: '',  // 关键物种
      bgcValue: '', //背景色
      alphaValue: '',  //透明度
      pointColorValue: '',  //散点颜色
      errMessInt: '',
      nonGroup: false,
      ending: null,
      dragging: null,
      options: [{
        value: 'sans',
        label: 'Arial'
      },
        {
          value: 'serif',
          label: 'Times New Roman'
        },
        {
          value: 'mono',
          label: 'Courier New'
        }],
      rules: {
        mainTitleRule: [
          {required: true, message: '不能输入中文字体', trigger: 'blur'},

        ],
        widthRule: [
          {type: 'number', required: true, message: '只能输入数字', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    //避免拖拽移动时会打开网页
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    // this.judgeNoGroup()
    this.isReRunAnalyze = getDataInSessionStorage('isReRunAnalyze')==='true'
    this.getParam()
    // this.checkVersion()
  },
  methods: {
    judgeNoGroup() {
      getAnalyzeGroupSampleNames(this.analyzeId).then(data => {
        this.nonGroup = data.nonGroup
      })
    },
    checkVersion() {
      this.$http.get('/analyze/checkVersion/' + this.analyzeId).then(response => {
        if (!response.data) {
          this.$confirmUi('项目的版本已发生重大改变，该分析将不提供绘图参数的修改。建议重跑该分析，若不重跑则不能在线修改绘图参数, 是否重跑该分析?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            getAnalyzeGroupSampleNames(this.analyzeId).then(groupSampleName => {
              if (groupSampleName) {
                this.reRunGroupSample = groupSampleName
                this.showReRunAnalyzeDialog = true
              } else {
                this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
              }
            }).catch(err => {
              this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
            })
          }).catch(() => {
          })
        }
      })
    },
    reRunAnalyze(groupColor, analyzeId, type) {
      this.showReRunAnalyzeDialog = false
      if (type === 'confirm') {
        reRunAnalyze(groupColor, analyzeId).then(res => {
          if (res === 'success') {
            this.$messageUi.success("重新运行成功")
            this.$router.push('/analyze?projectId=' + this.projectId)
          }
        }).catch(err => {
          this.$messageUi.error("重新运行失败")
        })
      }
    },
    handleColorChange(fieldName) {
      this.$nextTick(() => {
        this.$validator.validate(fieldName).then(valid => {
          if (valid) {
            this.$forceUpdate(); // 强制重新渲染组件，确保更新后的错误提示信息得以显示
          }
        });
      });
    },
    checkRang(value1, value2) {
      if (((value1 < value2) && value1 !== '') || (value1 === value2 && value1 === '')) {
        return false
      } else {
        return true
      }
    },

    checkMes(value, type,) {
      if (type === 'color') {
        this.errMess = '颜色格式错误或为空'
        return checkIsColor(value)
        // }
      } else if (type === 'number') {
        this.errMess = '数字格式错误'
        if (value) {
          return checkIsNumber(value)
        } else {
          return true
        }
      } else if (type === 'number1') {
        this.errMess = '数字格式错误'
        if (value) {
          return checkIsNumber1(value)
        } else {
          return true
        }
      } else if (type === 'int') {
        this.errMessInt = '填写自然数'
        if (value) {
          return checkIsIntNumber(value)
        } else {
          return true
        }
      } else {
        return false
      }
    },
    //参数重置
    resetParam() {
      let that = this
      this.$confirmUi('此操作将会使所有参数恢复默认值, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fillValue(this.defaultParam, 'default')
        that.$messageUi({
          type: 'success',
          message: '恢复成功!'
        });
      })
    },
    //获取参数
    async getParam() {
      if (!this.folder) {
        this.fullscreenLoading = false
      } else {
        const res = await this.$http.get('analyze/getParam/' + this.analyzeId + "/" + this.folder)
        if (res) {
          if (res.code === 200) {
            this.lastParam = res.data.lastTime
            this.defaultParam = res.data.default
            if (JSON.stringify(res.data.default) !== "{}") {
              let length = this.getFunction(this.lastParam)
              if (length >= 2) {
                this.paramEmpty = true
                this.notice = false
                // console.log(res.data.lastTime['colorLabel'], '数')
                await this.fillValue(this.lastParam, 'last')
                this.fullscreenLoading = false
              } else {
                this.paramEmpty = false
                this.notice = true
                this.fullscreenLoading = false
              }
            } else {
              this.paramEmpty = false
              this.notice = true
              this.fullscreenLoading = false
            }
          }

        }
      }
    },
    getFunction(obj) {
      let length = 0
      Object.keys(obj).forEach(key => {
        let value = obj[key]
        if (key === 'function') {
          this.functionName = value
        }
        length++
      })
      return length
    },
    // 为参数赋值
    fillValue(obj, type) {
      Object.keys(obj).forEach(key => {
        let value = obj[key]
        if (type === 'last') {
          //因为默认的分组颜色和分组名的数量对不上
          if (key === 'groupColorLabel') {
            this.colorParam = true
            let value1 = value.split(":")
            for (var i = 0; i < value1.length; i++) {
              this.groupColorLabel.push({
                key: value1[i] + i,
                value: value1[i]
              })
            }
          }
          //与上面同理
          if (key === 'colorLabel') {
            this.colorParam = true
            this.param.color = true
            this.colorLab = []
            let value1 = value.split(":")
            // value1= this.combine_ids(value1)
            for (var i = 0; i < value1.length; i++) {
              this.colorLab.push({
                key: value1[i] + i,
                value: value1[i]
              })
            }
          }
        }
        if (key === 'groupOrder') {
          this.pictureTool = true
          this.param.groupOrder = true
          this.groupOrderValue = []
          let value1 = value.split(":")
          // value1= this.combine_ids(value1)
          for (var i = 0; i < value1.length; i++) {
            this.groupOrderValue.push({
              value: value1[i]
            })
          }
        }
        if (key === 'sampleOrder') {
          this.pictureTool = true
          this.param.sampleOrder = true
          this.sampleOrderValue = []
          let value1 = value.split(":")
          // value1= this.combine_ids(value1)
          for (var i = 0; i < value1.length; i++) {
            this.sampleOrderValue.push({
              value: value1[i]
            })
          }
        }
        if (key === 'yls') {
          this.fontParam = true
          this.param.yTitleSize = true
          this.yTitleSizeValue = value
        }
        if (key === 'xls') {
          this.fontParam = true
          this.param.xTitleSize = true
          this.xTitleSizeValue = value
        }
        if (key === 'mainTitle') {
          this.fontParam = true
          this.param.mainTitle = true
          this.mainTitleValue = value
        }
        if (key === 'mainTitle2') {
          this.fontParam = true
          this.param.mainTitle2 = true
          this.mainTitle2Value = value
        }
        if (key === 'subTitleSize') {
          this.fontParam = true
          this.param.subTitleSize = true
          this.subTitleSizeValue = value
        }
        if (key === 'mtfs') {
          this.fontParam = true
          this.param.titleFontSize = true
          this.titleFontSizeValue = value
        }
        if (key === 'xts') {
          this.fontParam = true
          this.param.xSize = true
          this.xSizeValue = value
        }
        if (key === 'yts') {
          this.fontParam = true
          this.param.ySize = true
          this.ySizeValue = value
        }
        if (key === 'ts') {
          this.fontParam = true
          this.param.ts = true
          this.tsValue = value
        }
        if (key === 'ls') {
          this.fontParam = true
          this.param.ls = true
          this.lsValue = value
        }
        if (key === 'labfs') {
          this.fontParam = true
          this.param.labelFontSize = true
          this.labelFontSizeValue = value
        }
        if (key === 'family') {
          this.fontParam = true
          this.param.family = true
          this.familyValue = value
        }
        if (key === 'showXYNames') {
          this.fontParam = true
          this.param.showXYNames = true
          let value1 = value.split(":")
          this.showXNameValue = value1[0]
          this.showYNameValue = value1[1]
        }
        if (key === 'displayNumbers') {
          this.fontParam = true
          this.param.displayNumbers = true
          this.displayNumbersValue = value.toString()
        }
        if (key === 'showEnv') {
          this.param.showEnv = true
          this.showEnvValue = value.toString()
        }
        if (key === 'showNodeLabel') {
          this.param.showNodeLabel = true
          this.showNodeLabelValue = value.toString()
        }
        if (key === 'drawMethod') {
          this.param.drawMethod = true
          this.drawMethodValue = value
        }
        if (key === 'directionOfBar') {
          this.param.directionOfBar = true
          this.directionOfBarValue = value
        }
        if (key === 'lowLevelGroupInterval') {
          this.fontParam = true
          this.param.lowLevelGroupInterval = true
          this.lowLevelGroupIntervalValue = value
        }
        if (key === 'maxClassifyLevelNum') {
          this.fontParam = true
          this.param.maxClassifyLevelNum = true
          this.maxClassifyLevelNumValue = value
        }
        if (key === 'radialTopLevelNum') {
          this.fontParam = true
          this.param.radialTopLevelNum = true
          this.radialTopLevelNumValue = value
        }
        if (key === 'labLevelStart') {
          this.fontParam = true
          this.param.labLevelStart = true
          this.labLevelStartValue = value
        }
        if (key === 'labLevelEnd') {
          this.fontParam = true
          this.param.labLevelEnd = true
          this.labLevelEndValue = value
        }
        if (key === 'nodeSizeMin') {
          this.param.nodeSizeMin = true
          this.nodeSizeMinValue = value
        }
        if (key === 'nodeSizeMax') {
          this.param.nodeSizeMax = true
          this.nodeSizeMaxValue = value
        }
        if (key === 'yMax') {
          this.param.yMax = true
          this.yMaxValue = value
          $(document.body).off('click', '.wen').on('click', '.wen', '', function () {
          })
        }
        if (key === 'yMin') {
          this.param.yMin = true
          this.yMinValue = value
        }
        if (key === 'treeRoot') {
          this.param.treeRoot = true
          this.treeRootValue = value
        }
        if (key === 'evolutionBranchLabDia') {
          this.fontParam = true
          this.param.evolutionBranchLabDia = true
          this.evolutionBranchLabDiaValue = value
        }
        if (key === 'nodeMarginLineWidth') {
          this.fontParam = true
          this.param.nodeMarginLineWidth = true
          this.nodeMarginLineWidthValue = value
        }
        if (key === 'sblingNodeConnLineWidth') {
          this.fontParam = true
          this.param.sblingNodeConnLineWidth = true
          this.sblingNodeConnLineWidthValue = value
        }
        if (key === 'parentNodeConnLineWidth') {
          this.fontParam = true
          this.param.parentNodeConnLineWidth = true
          this.parentNodeConnLineWidthValue = value
        }
        if (key === 'rightSpaceProp') {
          this.fontParam = true
          this.param.rightSpaceProp = true
          this.rightSpacePropValue = value
        }
        if (key === 'legendncol') {
          this.fontParam = true
          this.param.legendncol = true
          this.legendncolValue = value
        }
        if (key === 'labAbbreLevelStart') {
          this.param.labAbbreLevelStart = true
          this.labAbbreLevelStartValue = value
        }
        if (key === 'labAbbreLevelEnd') {
          this.param.labAbbreLevelEnd = true
          this.labAbbreLevelEndValue = value
        }
        if (key === 'displayNumber') {
          this.fontParam = true
          this.param.displayNumber = true
          this.displayNumberValue = value
        }
        if (key === 'hasLab' || key === 'showLabel') {
          this.fontParam = true
          this.param.displayLabel = true
          this.displayLabelValue = value.toString()
        }
        //小写需要转json
        if (key === 'hasCircle') {
          this.fontParam = true
          this.param.displayCircle = !this.nonGroup
          this.displayCircleValue = value.toString()
        }
        if (key === 'drawMean') {
          this.fontParam = true
          this.param.drawMean = true
          this.drawMeanValue = value.toString()
        }
        if (key === 'drawMedian') {
          this.fontParam = true
          this.param.drawMedian = true
          this.drawMedianValue = value.toString()
        }
        if (key === 'showText') {
          this.fontParam = true
          this.param.showText = true
          this.showTextValue = value.toString()
        }
        if (key === 'isMerge') {
          this.fontParam = true
          this.param.isMerge = true
          this.isMergeValue = value.toString()
        }
        if (key === 'originPoint') {
          this.param.originPoint = true
          let value1 = value.split(":")
          this.originXPointValue = value1[0]
          this.originYPointValue = value1[1]
        }
        if (key === 'rowColumnInnerOfFont') {
          this.fontParam = true
          this.param.rowColumnInnerOfFont = true
          let value1 = value.split(":")
          this.rowFontSizeValue = +value1[0]
          this.colFontSizeValue = +value1[1]
          this.innerFontSizeValue = +value1[2]
        }
        if (key === 'fsNumber') {
          this.fontParam = true
          this.param.fsNumber = true
          this.innerFontSizeValue = value
        }
        if (key === 'showColNames' || key === 'cols') {
          this.fontParam = true
          this.param.showColNames = true
          this.showColNamesValue = value.toString()
        }
        if (key === 'showRowNames' || key === 'rows') {
          this.fontParam = true
          this.param.showRowNames = true
          this.showRowNamesValue = value.toString()
        }
        if (key === 'clusterRows') {
          this.fontParam = true
          this.param.clusterRows = true
          this.clusterRowsValue = value.toString()
        }
        if (key === 'clusterCols') {
          this.fontParam = true
          this.param.clusterCols = true
          this.clusterColsValue = value.toString()
        }
        if (key === 'envText') {
          this.fontParam = true
          this.param.colorParam = true
          this.param.envText = true
          let value1 = value.split(":")
          this.envTextColorValue = value1[0]
          this.envTextSizeValue = +value1[1]
        }
        if (key === 'envTextSize') {
          this.fontParam = true
          this.param.envTextSize = true
          this.envTextSizeValue = value
        }
        if (key === 'featureNameMaxLen') {
          this.fontParam = true
          this.param.featureNameMaxLen = true
          this.featureNameMaxLenValue = value
        }
        if (key === 'classFontSize' || key === 'classNameFontSize') {
          this.fontParam = true
          this.param.classFontSize = true
          this.classFontSizeValue = value
        }
        if (key === 'labLevelNum') {
          this.fontParam = true
          this.param.labLevelNum = true
          this.labLevelNumValue = value
        }
        if (key === 'fontSize' || key === 'fs') {
          this.fontParam = true
          this.param.fontSize = true
          this.fontSizeValue = value
        }
        if (key === 'axisSize') {
          this.fontParam = true
          this.param.axisFontSize3D = true
          this.axisFontSize3DValue = value
        }
        if (key === 'legendSize') {
          this.param.legendSize = true
          this.legendSizeValue = value
        }
        if (key === 'rightSpaceNumber') {
          this.param.rightSpaceNumber = true
          this.rightSpaceNumberValue = value
        }
        if (key === 'legendTitleSize') {
          this.param.legendTitleSize = true
          this.legendTitleSizeValue = value
        }
        if (key === 'legendTextSize') {
          this.param.legendTextSize = true
          this.legendTextSizeValue = value
        }
        if (key === 'labSize') {
          this.fontParam = true
          this.param.labSize = true
          this.labSizeValue = value
        }
        if (key === 'subClassFontSize') {
          this.fontParam = true
          this.param.subClassFontSize = true
          this.subClassFontSizeValue = value
        }
        if (key === 'classLabTrans') {
          this.fontParam = true
          this.param.classLabTrans = true
          this.classLabTransValue = value
        }
        if (key === 'envTextColor') {
          this.colorParam = true
          this.param.envTextColor = true
          this.envTextColorValue = value
        }
        if (key === 'lineColor') {
          this.colorParam = true
          this.param.lineColor = true
          this.lineColorValue = value
        }
        if (key === 'disColor') {
          this.colorParam = true
          this.param.abundanceColor = true
          this.abundanceColorValue = value
        }
        if (key === 'lowToHighColor') {
          this.colorParam = true
          this.param.lowToHighColor = true
          let value1 = value.split(":")
          this.lowColorValue = value1[0]
          this.highColorValue = value1[1]
        }

        if (key === 'sampleNameColor') {
          this.colorParam = true
          this.param.sampleNameColor = true
          this.sampleNameColorValue = value
        }
        if (key === 'dotMatrixColor') {
          this.colorParam = true
          this.param.dotMatrixColor = true
          this.dotMatrixColorValue = value
        }
        if (key === 'heapmapMaxColor') {
          this.colorParam = true
          this.param.heapmapMaxColor = true
          this.heapmapMaxColorValue = value
        }
        if (key === 'naColor') {
          this.colorParam = true
          this.param.naColor = true
          this.naColorValue = value
        }
        if (key === 'communityColor') {
          this.colorParam = true
          this.param.communityColor = true
          this.communityColorValue = value
        }
        if (key === 'metabolomeColor') {
          this.colorParam = true
          this.param.metabolomeColor = true
          this.metabolomeColorValue = value
        }
        if (key === 'negativeColor') {
          this.colorParam = true
          this.param.negativeColor = true
          this.negativeColorValue = value
        }
        if (key === 'justColor') {
          this.colorParam = true
          this.param.justColor = true
          this.justColorValue = value
        }
        if (key === 'metaboliteColor') {
          this.colorParam = true
          this.param.metaboliteColor = true
          this.metaboliteColorValue = value
        }
        if (key === 'speciesColor') {
          this.colorParam = true
          this.param.speciesColor = true
          this.speciesColorValue = value
        }
        if (key === 'color') {
          this.colorParam = true
          this.param.color = true
          this.colors = []
          let colorLabelLength = this.colorLab.length
          let value1 = value.split(":")
          // value1= this.combine_ids(value1)
          for (var i = 0; i < value1.length; i++) {
            this.colors.push({
              key: value1[i] + i,
              value: value1[i]
            })
          }
        }

        if (key === 'mapColor') {
          this.colorParam = true
          this.param.mapColor = true
          this.mapColors = []
          let value1 = value.split(":")
          // value1= this.combine_ids(value1)
          for (var i = 0; i < value1.length; i++) {
            this.mapColors.push({
              key: value1[i] + i,
              value: value1[i]
            })
          }
        }
        if (key === 'borderNumberCol') {
          this.colorParam = true
          this.param.borderNumberCol = true
          this.borderNumberCol = []
          let value1 = value.split(":")
          this.borderColorValue = value1[0]
          this.numberColorValue = value1[1]
        }
        if (key === 'groupColor') {
          this.colorParam = true
          this.param.groupColor = true
          this.groupColors = []
          let value1 = value.split(":")
          // value1= this.combine_ids(value1)
          for (var i = 0; i < value1.length; i++) {
            this.groupColors.push({
              key: value1[i] + i,
              value: value1[i]
            })
          }
        }

        if (key === 'circleColor') {
          this.colorParam = true
          this.param.circleColor = true
          this.circleColorValue = value
        }
        if (key === 'numberColor') {
          this.colorParam = true
          this.param.numberColor = true
          this.numberColorValue = value
        }
        if (key === 'pointColor') {
          this.colorParam = true
          this.param.pointColor = true
          this.pointColorValue = value
        }
        if (key === 'bgc') {
          this.colorParam = true
          this.param.bgc = true
          this.bgcValue = value
        }
        if (key === 'axisColor') {
          this.colorParam = true
          this.param.axisColor = true
          this.axisColorValue = value
        }
        if (key === 'gridColor') {
          this.colorParam = true
          this.param.gridColor = true
          this.gridColorValue = value
        }
        if (key === 'envTextBGColor') {
          this.colorParam = true
          this.param.envTextBGColor = true
          this.envTextBGColorValue = value
        }
        if (key === 'envilineColor') {
          this.colorParam = true
          this.param.enviLineColor = true
          this.enviLineColorValue = value
        }
        if (key === 'histColor') {
          this.colorParam = true
          this.param.histColor = true
          this.histColorValue = value
        }
        if (key === 'diaphaneity' || key === 'alpha') {
          this.colorParam = true
          this.param.diaphaneity = true
          this.diaphaneityValue = value
        }

        if (key === 'layout') {
          this.param.layout = true
          this.layoutValue = value
        }
        if (key === 'keystoneSpeciesTopNum') {
          this.param.keystoneSpeciesTopNum = true
          this.keystoneSpeciesTopNumValue = value
        }
        if (key === 'metabolinTopNum') {
          this.param.metabolinTopNum = true
          this.metabolinTopNumValue = value
        }
        if (key === 'width') {
          this.param.width = true
          this.widthValue = value
        }
        if (key === 'height') {
          this.param.height = true
          this.heightValue = value
        }
        if (key === 'ldaValue') {
          this.param.lda = true
          this.ldaValue = value
        }
        if (key === 'xlim') {
          this.param.xAxisLim = true
          if (value.indexOf(':') !== -1) {
            let value1 = value.split(":")
            this.xAxisLimMinValue = value1[0]
            this.xAxisLimMaxValue = value1[1]
          } else {
            this.xAxisLimMinValue = ''
            this.xAxisLimMaxValue = ''
          }
        }
        if (key === 'ylim') {
          this.param.yAxisLim = true
          if (value.indexOf(':') !== -1) {
            let value1 = value.split(":")
            this.yAxisLimMinValue = value1[0]
            this.yAxisLimMaxValue = value1[1]
          } else {
            this.yAxisLimMinValue = ''
            this.yAxisLimMaxValue = ''
          }
        }
        if (key === 'zlim') {
          this.param.zAxisLim = true
          if (value.indexOf(':') !== -1) {
            let value1 = value.split(":")
            this.zAxisLimMinValue = value1[0]
            this.zAxisLimMaxValue = value1[1]
          } else {
            this.zAxisLimMinValue = ''
            this.zAxisLimMaxValue = ''
          }
        }
        if (key === 'function') {
          this.function = this.functionName
        }
      })
      this.$store.commit('setModifyLoading', 'param')
    },
//点击绘制按钮
    draw() {
      this.checkParam().then(result => {
        if (result) {
          Object.keys(this.lastParam).forEach(key => {
            if (key === 'yls') {
              this.returnParam[key] = this.yTitleSizeValue
            }
            if (key === 'xls') {
              this.returnParam[key] = this.xTitleSizeValue
            }
            if (key === 'mainTitle') {
              this.returnParam[key] = this.mainTitleValue
            }
            if (key === 'mainTitle2') {
              this.returnParam[key] = this.mainTitle2Value
            }
            if (key === 'subTitleSize') {
              this.returnParam[key] = this.subTitleSizeValue
            }
            if (key === 'mtfs') {
              this.returnParam[key] = this.titleFontSizeValue
            }
            if (key === 'xts') {
              this.returnParam[key] = this.xSizeValue
            }
            if (key === 'yts') {
              this.returnParam[key] = this.ySizeValue
            }
            if (key === 'ts') {
              this.returnParam[key] = this.tsValue
            }
            if (key === 'ls') {
              this.returnParam[key] = this.lsValue
            }
            if (key === 'labfs') {
              this.returnParam[key] = this.ySizeValue
            }
            if (key === 'fsNumber') {
              this.returnParam[key] = this.innerFontSizeValue
            }
            if (key === 'legendTextSize') {
              this.returnParam[key] = +this.legendTextSizeValue
            }
            if (key === 'family') {
              this.returnParam[key] = this.familyValue
            }
            if (key === 'featureNameMaxLen') {
              this.returnParam[key] = this.featureNameMaxLenValue
            }
            if (key === 'classFontSize' || key === 'classNameFontSize') {
              this.returnParam[key] = this.classFontSizeValue
            }
            if (key === 'labLevelNum') {
              this.returnParam[key] = +this.labLevelNumValue
            }
            if (key === 'lowLevelGroupInterval') {
              this.returnParam[key] = +this.lowLevelGroupIntervalValue
            }
            if (key === 'maxClassifyLevelNum') {
              this.returnParam[key] = +this.maxClassifyLevelNumValue
            }
            if (key === 'radialTopLevelNum') {
              this.returnParam[key] = +this.radialTopLevelNumValue
            }
            if (key === 'labLevelStart') {
              this.returnParam[key] = +this.labLevelStartValue
            }
            if (key === 'labLevelEnd') {
              this.returnParam[key] = +this.labLevelEndValue
            }
            if (key === 'labAbbreLevelStart') {
              this.returnParam[key] = +this.labAbbreLevelStartValue
            }
            if (key === 'labAbbreLevelEnd') {
              this.returnParam[key] = +this.labAbbreLevelEndValue
            }
            if (key === 'nodeSizeMin') {
              this.returnParam[key] = +this.nodeSizeMinValue
            }
            if (key === 'nodeSizeMax') {
              this.returnParam[key] = +this.nodeSizeMaxValue
            }
            if (key === 'yMin') {
              this.returnParam[key] = +this.yMinValue
            }
            if (key === 'yMax') {
              this.returnParam[key] = +this.yMaxValue
            }
            if (key === 'treeRoot') {
              this.returnParam[key] = this.treeRootValue
            }
            if (key === 'subClassFontSize') {
              this.returnParam[key] = this.subClassFontSizeValue
            }
            if (key === 'classLabTrans') {
              this.returnParam[key] = this.classLabTransValue
            }
            if (key === 'evolutionBranchLabDia') {
              this.returnParam[key] = +this.evolutionBranchLabDiaValue
            }
            if (key === 'nodeMarginLineWidth') {
              this.returnParam[key] = +this.nodeMarginLineWidthValue
            }
            if (key === 'sblingNodeConnLineWidth') {
              this.returnParam[key] = +this.sblingNodeConnLineWidthValue
            }
            if (key === 'parentNodeConnLineWidth') {
              this.returnParam[key] = +this.parentNodeConnLineWidthValue
            }
            if (key === 'rightSpaceProp') {
              this.returnParam[key] = +this.rightSpacePropValue
            }
            if (key === 'legendncol') {
              this.returnParam[key] = +this.legendncolValue
            }
            if (key === 'displayNumber') {
              this.returnParam[key] = this.displayNumberValue
            }
            if (key === 'hasCircle') {
              this.returnParam[key] = JSON.parse(this.displayCircleValue)
            }
            if (key === 'hasLab' || key === 'showLabel') {
              this.returnParam[key] = JSON.parse(this.displayLabelValue)
            }
            if (key === 'showText') {
              this.returnParam[key] = JSON.parse(this.showTextValue)
            }
            if (key === 'showNodeLabel') {
              this.returnParam[key] = JSON.parse(this.showNodeLabelValue)
            }
            if (key === 'isMerge') {
              this.returnParam[key] = JSON.parse(this.isMergeValue)
            }
            if (key === 'showColNames' || key === 'cols') {
              this.returnParam[key] = JSON.parse(this.showColNamesValue)
            }
            if (key === 'showRowNames' || key === 'rows') {
              this.returnParam[key] = JSON.parse(this.showRowNamesValue)
            }
            if (key === 'clusterRows') {
              this.returnParam[key] = JSON.parse(this.clusterRowsValue)
            }
            if (key === 'drawMean') {
              this.returnParam[key] = JSON.parse(this.drawMeanValue)
            }
            if (key === 'drawMedian') {
              this.returnParam[key] = JSON.parse(this.drawMedianValue)
            }
            if (key === 'clusterCols') {
              this.returnParam[key] = JSON.parse(this.clusterColsValue)
            }
            if (key === 'displayNumbers') {
              this.returnParam[key] = JSON.parse(this.displayNumbersValue)
            }
            if (key === 'showXYNames') {
              this.returnParam[key] = this.showXNameValue + ':' + this.showYNameValue
            }
            if (key === 'envText') {
              this.returnParam[key] = this.envTextColorValue + ':' + this.envTextSizeValue
            }
            if (key === 'rowColumnInnerOfFont') {
              this.returnParam[key] = this.rowFontSizeValue + ':' + this.colFontSizeValue + ':' + this.innerFontSizeValue
            }
            if (key === 'lowToHighColor') {
              this.returnParam[key] = this.lowColorValue + ':' + this.highColorValue
            }
            if (key === 'envTextColor') {
              this.returnParam[key] = this.envTextColorValue
            }
            if (key === 'lineColor') {
              this.returnParam[key] = this.lineColorValue
            }
            if (key === 'dotMatrixColor') {
              this.returnParam[key] = this.dotMatrixColorValue
            }
            if (key === 'heapmapMaxColor') {
              this.returnParam[key] = this.heapmapMaxColorValue
            }
            if (key === 'naColor') {
              this.returnParam[key] = this.naColorValue
            }
            if (key === 'communityColor') {
              this.returnParam[key] = this.communityColorValue
            }
            if (key === 'metabolomeColor') {
              this.returnParam[key] = this.metabolomeColorValue
            }
            if (key === 'negativeColor') {
              this.returnParam[key] = this.negativeColorValue
            }
            if (key === 'justColor') {
              this.returnParam[key] = this.justColorValue
            }
            if (key === 'metaboliteColor') {
              this.returnParam[key] = this.metaboliteColorValue
            }
            if (key === 'speciesColor') {
              this.returnParam[key] = this.speciesColorValue
            }
            if (key === 'numberColor') {
              this.returnParam[key] = this.numberColorValue
            }
            if (key === 'bgc') {
              this.returnParam[key] = this.bgcValue
            }
            if (key === 'pointColor') {
              this.returnParam[key] = this.pointColorValue
            }
            if (key === 'envTextSize') {
              this.returnParam[key] = this.envTextSizeValue
            }
            if (key === 'fontSize' || key === 'fs') {
              this.returnParam[key] = this.fontSizeValue
            }
            if (key === 'labfs') {
              this.returnParam[key] = this.labelFontSizeValue
            }
            if (key === 'labSize') {
              this.returnParam[key] = this.labSizeValue
            }
            if (key === 'rightSpaceNumber') {
              this.returnParam[key] = +this.rightSpaceNumberValue
            }
            if (key === 'axisSize') {
              this.returnParam[key] = this.axisFontSize3DValue
            }
            if (key === 'legendSize') {
              this.returnParam[key] = +this.legendSizeValue
            }
            if (key === 'legendTitleSize') {
              this.returnParam[key] = +this.legendTitleSizeValue
            }
            if (key === 'directionOfBar') {
              this.returnParam[key] = this.directionOfBarValue
            }
            if (key === 'drawMethod') {
              this.returnParam[key] = this.drawMethodValue
            }

            if (key === 'color') {
              let returnColorArr = []
              this.colors.forEach(function (elem) {
                returnColorArr.push(elem.value)
              })
              let returnColor = returnColorArr.join(":")
              this.returnParam[key] = returnColor
            }
            if (key === 'mapColor') {
              let returnColorArr = []
              this.mapColors.forEach(function (elem) {
                returnColorArr.push(elem.value)
              })
              let returnColor = returnColorArr.join(":")
              this.returnParam[key] = returnColor
            }
            if (key === 'sampleNameColor') {
              this.returnParam[key] = this.sampleNameColorValue
            }
            // if (key === 'borderNumberCol') {
            //   let returnBorderColorArr = []
            //   this.borderColors.forEach(function (elem) {
            //     returnBorderColorArr.push(elem.value)
            //   })
            //   let returnBorderColor = returnBorderColorArr.join(":")
            //   this.returnParam[key] = returnBorderColor
            // }
            if (key === 'borderNumberCol') {
              this.returnParam[key] = this.borderColorValue + ':' + this.numberColorValue
            }
            if (key === 'groupColor') {
              let returnGroupColorArr = []
              this.groupColors.forEach(function (elem) {
                returnGroupColorArr.push(elem.value)
              })
              let returnGroupColor = returnGroupColorArr.join(":")
              this.returnParam[key] = returnGroupColor
            }
            if (key === 'circleColor') {
              this.returnParam[key] = this.circleColorValue
            }
            if (key === 'axisColor') {
              this.returnParam[key] = this.axisColorValue
            }
            if (key === 'gridColor') {
              this.returnParam[key] = this.gridColorValue
            }
            if (key === 'envilineColor') {
              this.returnParam[key] = this.enviLineColorValue
            }
            if (key === 'envTextBGColor') {
              this.returnParam[key] = this.envTextBGColorValue
            }
            if (key === 'disColor') {
              this.returnParam[key] = this.abundanceColorValue
            }
            if (key === 'histColor') {
              this.returnParam[key] = this.histColorValue
            }
            if (key === 'diaphaneity' || key === 'alpha') {
              this.returnParam[key] = this.diaphaneityValue
            }
            if (key === 'showEnv') {
              this.returnParam[key] = JSON.parse(this.showEnvValue)
            }
            if (key === 'layout') {
              this.returnParam[key] = this.layoutValue
            }
            if (key === 'keystoneSpeciesTopNum') {
              this.returnParam[key] = this.keystoneSpeciesTopNumValue
            }
            if (key === 'metabolinTopNum') {
              this.returnParam[key] = this.metabolinTopNumValue
            }
            if (key === 'height') {
              this.returnParam[key] = +this.heightValue//避免字符串
            }
            if (key === 'width') {
              this.returnParam[key] = +this.widthValue
            }
            if (key === 'ldaValue') {
              this.returnParam[key] = +this.ldaValue
            }
            if (key === 'xlim') {
              if (this.xAxisLimMinValue === '' && this.xAxisLimMaxValue === '') {
                this.returnParam[key] = ''
              } else {
                this.returnParam[key] = this.xAxisLimMinValue + ":" + this.xAxisLimMaxValue
              }
            }
            if (key === 'ylim') {
              if (this.yAxisLimMinValue === '' && this.yAxisLimMaxValue === '') {
                this.returnParam[key] = ''
              } else {
                this.returnParam[key] = this.yAxisLimMinValue + ":" + this.yAxisLimMaxValue
              }
            }
            if (key === 'zlim') {
              if (this.zAxisLimMinValue === '' && this.zAxisLimMaxValue === '') {
                this.returnParam[key] = ''
              } else {
                this.returnParam[key] = this.zAxisLimMinValue + ":" + this.zAxisLimMaxValue
              }
            }
            if (key === 'originPoint') {
              this.returnParam[key] = this.originXPointValue + ':' + this.originYPointValue
            }
            if (key === 'function') {
              this.returnParam[key] = this.function
            }
            if (key === 'groupOrder') {
              let returnGroupOrder = []
              this.groupOrderValue.forEach(function (elem) {
                returnGroupOrder.push(elem.value)
              })
              this.returnParam[key] = returnGroupOrder.join(":")
              // this.returnParam[key] = this.groupOrderValue.join(":")
            }
            if (key === 'sampleOrder') {
              let returnSampleOrder = []
              this.sampleOrderValue.forEach(function (elem) {
                returnSampleOrder.push(elem.value)
              })
              this.returnParam[key] = returnSampleOrder.join(":")
              // this.returnParam[key] = this.groupOrderValue.join(":")
            }
          })
          let returnParamJson = JSON.stringify(this.returnParam)
          this.passDraw(returnParamJson)
        } else {
          return
        }
      })
    },
    //将绘图参数信息发给后端
    async passDraw(returnParamJson) {
      // var loading = this.$showPublicLoading()
      this.drawingNotice = true
      // this.drawNotice=true
      // this.dialogVisible=true
      const res = await this.$http({
        method: 'post',
        url: 'analyze/execOne/' + this.analyzeId + "/" + this.folder,
        headers: {"Content-Type": "application/json"},
        data: returnParamJson
      }).catch((error) => {
        // loading.close()
        this.drawingNotice = false
      })

      if (res.code === 200) {
        this.$emit('updatePdf', this.folder, this.index, this.countType)
        // this.$emit('updatePdf', this.folder)
        // await this.$refs.filePdf.getFirstPdf()
        // this.drawNotice=false
        // this.dialogVisible=false
        this.drawingNotice = false
      } else {
        this.dialogVisible = true
        setTimeout(() => {
          this.drawingNotice = false
        }, 100)
        this.drawErrMess = res.data
        this.drawErrTitle = res.message
      }
    },
    //检查绘图参数是否合法
    async checkParam() {
      let flag = false
      let errObject = this.err
      Object.keys(errObject).forEach(key => {
        let value = errObject[key]
        if (value.length > 1) {
          value.forEach(y => {
            if (y === true) {
              flag = true
            }
          })
        } else {
          if (value === true) {
            flag = true
          }
        }
      })
      let flagValidate = await this.checkvalidateFlag()
      if (this.xErrNumber || this.yErrNumber || this.zErrNumber || flag === true || flagValidate === "true") {
        this.$alert('有参数不合法，请核实！', '参数设置错误', {
          confirmButtonText: '确定',
          type: 'warning',
        });
        return false
      } else {
        return true
      }
    },
    //新增颜色
    addColor() {
      this.addClickNum++
      let chooseColor = defaultColor[this.addClickNum % defaultColor.length]
      this.mapColors.push({
        key: chooseColor + this.addClickNum,
        value: chooseColor,
      })
    },
    //删除颜色
    deleteColor(index) {
      let colorNumber = this.mapColors.length
      if (colorNumber <= 2) {
        this.$alert('删除颜色失败，颜色最小数量为2个', '删除颜色失败', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
            this.$messageUi({
              type: 'warning',
              message: `已取消删除`
            });
          }
        });
      } else {
        this.mapColors.splice(index, 1)
      }
    },
    //大小判断
    compare(type) {
      if (type === 'x') {
        var flag = this.compareInt(this.xAxisLimMinValue, this.xAxisLimMaxValue)
        this.xErrNumber = flag
      } else if (type === 'y') {
        var flag = this.compareInt(this.yAxisLimMinValue, this.yAxisLimMaxValue)
        this.yErrNumber = flag
      } else {
        var flag = this.compareInt(this.zAxisLimMinValue, this.zAxisLimMaxValue)
        this.zErrNumber = flag
      }
    },
    compareInt(a, b) {
      if (a === '' && b === '') {
        return false
      } else {
        a = parseInt(a)
        b = parseInt(b)
        if (a < b) {
          return false
        } else {
          return true
        }
      }
    },
    disappear(type) {
      if (type === 'x') {
        if ((this.xAxisLimMinValue === '' && this.xAxisLimMaxValue === '') || (this.xAxisLimMinValue < this.xAxisLimMaxValue && this.xAxisLimMinValue !== ''))
          this.xErrNumber = false
        else this.xErrNumber = true
      } else if (type === 'y') {
        if ((this.yAxisLimMinValue === '' && this.yAxisLimMaxValue === '') || (this.yAxisLimMinValue < this.yAxisLimMaxValue && this.yAxisLimMinValue !== ''))
          this.yErrNumber = false
        else this.yErrNumber = true
      } else {
        if ((this.zAxisLimMinValue === '' && this.zAxisLimMaxValue === '') || (this.zAxisLimMinValue < this.zAxisLimMaxValue && this.zAxisLimMinValue !== '')) {
          this.zErrNumber = false
        } else {
          this.zErrNumber = true
        }
      }
    },
    //检查参数合法性（vee-validate）
    checkvalidateFlag() {
      let flag = this.$validator.validateAll().then(result => {
        if (result) {
          return "false"
          // form submission logic goes here
        } else {
          return "true"
        }
      });
      return flag
    },
    handleDragStart(e, item) {
      console.log(item)
      this.dragging = item
    },
    handleDragEnd(e, item) {
      if (this.ending.value === this.dragging.value) {
        return;
      }
      let newItems = [...this.groupOrderValue]

      const src = newItems.indexOf(this.dragging)
      const dst = newItems.indexOf(this.ending)
      newItems.splice(src, 1, ...newItems.splice(dst, 1, newItems[src]))
      this.groupOrderValue = newItems
      this.$nextTick(() => {
        this.dragging = null
        this.ending = null
      });
    },
    handleDragOver(e) {
      // 首先把div变成可以放置的元素，即重写dragenter/dragover
      // 在dragenter中针对放置目标来设置
      e.dataTransfer.dropEffect = "move"
    },
    handleDragEnter(e, item) {
      // 为需要移动的元素设置dragstart事件
      e.dataTransfer.effectAllowed = "move"
      this.ending = item
    },
  },
}
</script>

<style scoped>
.errMess {
  color: #933535;
  margin-left: 10px;
  font-size: 15px;
  width: 160px;
  font-family: "Microsoft YaHei";
  white-space: nowrap;
}

.el-form-item__label {
  font-family: "Microsoft YaHei";
}

/deep/ .el-dialog__header {
  background-color: #477cb2;
}

.colorPickerFont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*width: 60%;*/
}

.colorInput {
  /*width: 50%;*/
  min-width: 130px;
}

.wenHaoValue {
  font-family: "Microsoft YaHei";
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  white-space: nowrap;
}

.shapeStyle {
  display: flex;
  justify-content: space-between
}

.lineBetween {
  white-space: nowrap;
}

.slideStyle {
  min-width: 230px;
}

.elIconQuestion {
  cursor: pointer;
}

.betweenInput {
  min-width: 50px;
}

.errValMess {
  color: #933535;
}

/deep/ .el-dialog__mask {
  z-index: 1100;
}

/deep/ .el-dialog__wrapper {
  z-index: 1000;

}

.colorModel {
  width: 100%;
}

.input_pick_msg {
  vertical-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between
}

.colorPicker {
  margin-left: 30px
}

.select_inline {
  display: grid;
}

.divBorder {
  border: solid 1px #e3e2e2;
  padding: 15px;
  margin-bottom: 20px;
}
</style>
